/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import Button, { ButtonType, ButtonTheme } from '../../atoms/button/button';
import InputText from '../../atoms/inputText/inputText';
import { IconType } from '../../atoms/icon/icon';
import HelpButton from '../../atoms/helpButton/helpButton';
import FormCheckbox from '../../molecules/formCheckbox/formCheckbox';
import Checkbox from '../../atoms/checkbox/checkbox';
import FormSelect from '../formSelect/formSelect';
import Select from '../../atoms/select/select';

export const TableColumnType = {
  TEXT: 'text',
};

const TableHeader = (props) => {
  const {
    tableId,
    type,
    attributeName,
    label,
    width,
    exactWidth,
    small,
    hidden,
    canFilter,
    filterSelectOptions,
    canOrder,
    onSort,
    onFilter,
    helpText,
    multiselectable,
    onUpdateMultiselectable,
    initDataSelected,
    bulkValue,
    additionalCss
  } = props;
  const childRef = useRef();
  const location = useLocation();
  const [sortDowntate, setSortDowntate] = useState(true);
  const [selectAll,setSelectAll] =useState(false);

  const handleButtonShort = () => {
    const valueToSort = {
      attributeName,
      sortDown: sortDowntate,
    };
    onSort(valueToSort);
    setSortDowntate(!sortDowntate);
  };

  const handleFilter = (value) => {
    const valueToSort = {
      attributeName,
      value,
    };
    onFilter(valueToSort);
  };

  const setFiltersWithParams = () => {
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.get(attributeName)) {
      // console.log(childRef)
      childRef.current.updateValue(searchParams.get(attributeName));
    }
  };

  useEffect(() => {
    if (canFilter) {
      setFiltersWithParams();
    }
  }, [location]);

  useEffect(() => {
    if(initDataSelected && initDataSelected.length==0){
      setSelectAll(false);
    }
  }, [initDataSelected]);

  const handlerOnMultiselectableChange=()=>{
    // console.log("changed multiselectable",!selectAll);
    setSelectAll(!selectAll);

    onUpdateMultiselectable(!selectAll);
  }
  let colHeaderStyle={};
  if(exactWidth){
    colHeaderStyle.width=exactWidth;
  }else if(width){
    colHeaderStyle.maxWidth=width;
  }
  if(small==true){
    colHeaderStyle.paddingLeft=0;
    colHeaderStyle.paddingRight=0;
    colHeaderStyle.textAlign="center";
  }
  return (
    <th scope="col" style={colHeaderStyle} className={(hidden==true?"d-none ":"")+(additionalCss?additionalCss:"")}>
      {label}
      {helpText !== ''
        && <HelpButton>{helpText}</HelpButton>}
      { canOrder
      && (
      <Button
        id={`${tableId}-${attributeName}-orderButton`}
        theme={ButtonTheme.LIGH}
        icon={IconType.SORT}
        onClick={handleButtonShort}
        className="py-0"
      />
      )}
      
      {filterSelectOptions ? (canFilter 
      && <Select 
            name={`${attributeName}-filter-select`}
              id={`${tableId}-${attributeName}-filter-select`}
              ref={childRef}
              isFilter={true}
              options={filterSelectOptions}
              onChange={handleFilter}      
      
      />): (canFilter 
        && <InputText
          id={`${tableId}-${attributeName}-filter`}
          ref={childRef}
          name={`${attributeName}-filter`}
          type={type}
          placeholder={`${label} filter...`}
          onChange={handleFilter}
        />) }  
      
      {/* {
        canFilter && filterSelectOptions && ( <div>Hola</div>)
      }
      { canFilter && (filterSelectOptions==undefined)
      && (
        <InputText
          id={`${tableId}-${attributeName}-filter`}
          ref={childRef}
          name={`${attributeName}-filter`}
          type={type}
          placeholder={`${label} filter...`}
          onChange={handleFilter}
        />
      )} */}
      {multiselectable && 
      <Checkbox
      className="mx-auto"
      onChange={handlerOnMultiselectableChange}
      checked={selectAll}
      value={selectAll.toString()}
      id={"sel-all"}
    />
       }
    </th>
  );
};

TableHeader.propTypes = {
  tableId: PropTypes.string,
  type: PropTypes.oneOf(Object.values(TableColumnType)),
  attributeName: PropTypes.string.isRequired,
  label: PropTypes.string,
  width: PropTypes.string,
  canFilter: PropTypes.bool,
  canOrder: PropTypes.bool,
  onSort: PropTypes.func,
  onFilter: PropTypes.func,
  helpText: PropTypes.string,
};

TableHeader.defaultProps = {
  tableId: '',
  type: TableColumnType.TEXT,
  label: '',
  width: '',
  canFilter: false,
  canOrder: false,
  onSort: () => {},
  onFilter: () => {},
  helpText: '',
};

export default TableHeader;
